import * as React from 'react';

import AppFooter from './Modules/Views/AppFooter';
import { HomePageIntro } from './Modules/Views/HomePageIntro';
import { ProductFeatures } from './Modules/Views/ProductFeatures';
import { ProductHowItWorks } from './Modules/Views/ProductHowItWorks';
import { ProductCategories } from './Modules/Views/ProductCategories';
import { ContactUsEmail } from './Modules/Views/ContactUsEmail';
import { ContactUs } from './Modules/Views/ContactUs';
import { AppNavBar } from './Modules/Views/AppNavBar';
import withRoot from './Modules/withRoot';

function HomePage() {
	return (
		<React.Fragment>
			<AppNavBar />
			<HomePageIntro />
			<ProductFeatures />
			<ProductCategories />
			<ProductHowItWorks />
			<ContactUsEmail />
			<ContactUs />
			<AppFooter />
		</React.Fragment>
	);
}

export default withRoot(HomePage);
